import { render, staticRenderFns } from "./ImageVariable.vue?vue&type=template&id=715907a1&scoped=true&"
import script from "./ImageVariable.vue?vue&type=script&lang=js&"
export * from "./ImageVariable.vue?vue&type=script&lang=js&"
import style0 from "./ImageVariable.vue?vue&type=style&index=0&id=715907a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715907a1",
  null
  
)

export default component.exports